// Hub page content for the Employer Sponsored group.
// Sourced from docs/research/australian-visa-pathways.md §2.

const employerSponsoredHub = {
  groupSlug: "employer-sponsored",
  eyebrow: "Employer Sponsored",
  heading: "Employer sponsored visas",
  intro:
    "When an Australian employer wants to hire you for a role they cannot fill locally, an employer-sponsored visa can make it happen. These visas link your visa to a genuine job and an approved sponsor, and several of them lead to permanent residence. We prepare and organise every part of the paperwork for workers and employers, and match you with a registered migration agent who provides the advice and lodges.",

  howItWorks: {
    heading: "How employer sponsorship works",
    steps: [
      {
        title: "Sponsorship",
        detail:
          "The employer becomes an approved sponsor and takes on the obligations that come with it.",
      },
      {
        title: "Nomination",
        detail:
          "The employer nominates a genuine position and the worker who will fill it.",
      },
      {
        title: "Visa application",
        detail:
          "The worker lodges the visa application. The Department of Home Affairs decides the outcome.",
      },
      {
        title: "Pathway to PR",
        detail:
          "Time on a temporary or provisional sponsored visa can count toward permanent residence.",
      },
    ],
  },

  atAGlance: {
    heading: "Compare the employer-sponsored visas",
    columns: ["Visa", "Best for", "Result", "Sponsor"],
    rows: [
      {
        serviceSlug: "skills-in-demand-482",
        cells: [
          "Skills in Demand (482)",
          "Filling a skilled role now, with a PR pathway",
          "Temporary (pathway to 186)",
          "Approved Australian employer",
        ],
      },
      {
        serviceSlug: "employer-nomination-186",
        cells: [
          "Employer Nomination (186)",
          "Permanent residence through an employer",
          "Permanent residence",
          "Australian employer",
        ],
      },
      {
        serviceSlug: "regional-494",
        cells: [
          "Skilled Employer Regional (494)",
          "A regional employer and regional life",
          "Provisional (pathway to 191)",
          "Regional employer",
        ],
      },
    ],
  },

  faqs: [
    {
      q: "Do you find employers or sponsors for applicants?",
      a: "No. We are a migration support and coordination service, not recruiters, and we never promise a job or sponsorship. Once a genuine role and willing employer exist, we prepare and organise the sponsorship, nomination, and visa documentation, and a registered migration agent assesses eligibility and lodges.",
    },
    {
      q: "Which employer-sponsored visa leads to permanent residence?",
      a: "The 186 is permanent on grant. The 482 leads to permanent residence through the 186 after the required time with your sponsor, and the 494 leads to permanent residence through the 191 once the regional and income conditions are met.",
    },
    {
      q: "What are the employer's obligations?",
      a: "Sponsors must meet ongoing obligations, including paying the correct salary, keeping records, and covering certain costs such as the Skilling Australians Fund levy. We help employers organise the paperwork for all of it, and a registered migration agent advises on the obligations.",
    },
  ],

  lastVerified: "13 July 2026",
};

export default employerSponsoredHub;
